import { HttpErrorResponse } from "@angular/common/http";

import { FundWithRelated } from "@models/fund-with-related.model";
import { Nav } from "@models/nav.model";
import { NavPeriod } from "@models/nav-period.model";
import { TradeMoment } from "@models/trade-moment-model";
import { Yieldu } from "@models/yieldu-model";
import { createAction, props } from "@ngrx/store";

export const SET_TRADING_LOADING_STATUS = createAction(
  "[Trading] Set Trading Loading Status",
  props<{ loading: boolean }>()
);

export const SET_TRADING_ERROR = createAction(
  "[Trading] Set Trading Error",
  props<{ error: HttpErrorResponse }>()
);

export const LOAD_FUND_LIST = createAction("[Trading] Load Fund List");

export const SET_FUND_LIST = createAction(
  "[Trading] Set Fund List",
  props<{ fundList: Array<FundWithRelated> }>()
);

export const LOAD_LATEST_TRADING = createAction(
  "[Trading] Load Latest Trading",
  props<{ definitive: boolean }>()
);

export const SET_LATEST_TRADING = createAction(
  "[Trading] Set Latest Trading",
  props<{ tradeMoment: TradeMoment }>()
);

export const GENERATE_ORDER_BOOK = createAction(
  "[Trading] Generate Order Book"
);

export const UPDATE_TRANSACTIONS = createAction(
  "[Trading] Update Transactions"
);

export const LOAD_TRANSACTIONS_COUNT = createAction(
  "[Trading] Load Transactions Count"
);

export const SET_TRANSACTIONS_COUNT = createAction(
  "[Trading] Set Transactions Count",
  props<{ transactions: number }>()
);

export const POST_TRADING = createAction(
  "[Trading] Post Trading",
  props<{ tradingCanceled?: boolean }>()
);

export const DELETE_TRADING = createAction("[Trading] Delete Trading");

export const EXPORT_REPORT = createAction(
  "[Trading] Export Report",
  props<{ registerReport: boolean; dateStart?: Date; dateEnd?: Date }>()
);

export const GENERATE_NAV_HISTORY = createAction(
  "[Trading] Generate Nav History",
  props<{
    selectedIds: Array<string>;
    dateStart: string | null;
    dateEnd: string | null;
  }>()
);

export const SET_NAV_HISTORY = createAction(
  "[Trading] Set Nav History",
  props<{ navTable: Array<NavPeriod> }>() // TODO @Adrian add type after deploy
);

export const SAVE_PENDING_NAV = createAction(
  "[Trading] Save Pending Nav",
  props<{ navValues: Array<Nav> }>()
);

export const LOAD_YIELDU_EFFICIENCY = createAction(
  "[Trading] Load Yieldu Efficiency"
);

export const SET_YIELDU_EFFICIENCY = createAction(
  "[Trading] Set Yieldu Efficiency",
  props<{ yielduList: Array<Yieldu> }>()
);

export const SAVE_YIELDU_EFFICIENCY = createAction(
  "[Trading] Save Yieldu Efficiency",
  props<{ savedData: Array<Yieldu> }>()
);

export const LOAD_TRADE_STATUS = createAction("[Trading] Load Trade Status");

export const SET_TRADE_STATUS = createAction(
  "[Trading] Set Trade Status",
  props<{ tradeStatus: boolean }>()
);

export const SET_TRADING_MOMENT_LOADING_STATUS = createAction(
  "[Trading] Set Trading Moment Loading Status",
  props<{ tradeSectionLoading: boolean }>()
);
